var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 731,
    viewBox: "0 0 424 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1325_7190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 424,
    height: 731
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 731,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1325_7190)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.2133 110.997L171.877 132.704C187.471 136.61 203.771 129.748 211.877 115.864C227.113 89.7669 265.743 92.7753 276.756 120.917L325.028 244.271C330.419 258.048 338.8 270.457 349.567 280.604L487.089 410.209C523.573 444.593 500.826 505.934 450.745 508.217L436.432 508.869C395.746 510.724 374.546 558.142 400.294 589.699C433.189 630.015 389.656 687.303 342.001 666.41L275.372 637.197C256.976 629.132 235.935 629.732 218.029 638.834L106.721 695.411C63.7754 717.239 11.5582 694.712 -2.03079 648.494C-7.6683 629.32 -20.5406 613.09 -37.9268 603.234L-179.061 523.226C-225.695 496.79 -201.141 425.402 -148.113 433.245C-100.019 440.357 -72.6371 380.065 -109.64 348.531L-124.404 335.949C-168.633 298.256 -130.222 226.884 -74.4002 243.037L-6.07298 262.808C38.8646 275.812 72.3195 221.298 40.3761 187.12C9.02913 153.581 40.6813 99.843 85.2133 110.997Z",
    fill: "url(#paint0_linear_1325_7190)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1325_7190",
    x1: 372.505,
    y1: 89.3864,
    x2: 146.252,
    y2: 602.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED2F8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/sidebar-bg.4fd19c4a793686e3acd91459129d33c3.svg";
export { ForwardRef as ReactComponent };